(function () {
  var FULLSCREEN_PAGE_CLASS = "noxland-fullscreen-page";
  var SOUND_STORAGE_KEY = "noxland:sound";
  var DEFAULT_AUDIO_VOLUME = 0.25;
  var DEFAULT_AUDIO_FADE_MS = 1800;
  var DEFAULT_REACTIVE_BPM = 172;
  var KEY_DIRECTIONS = {
    ArrowUp: "up",
    ArrowDown: "down",
    ArrowLeft: "left",
    ArrowRight: "right",
    w: "up",
    W: "up",
    z: "up",
    Z: "up",
    s: "down",
    S: "down",
    a: "left",
    A: "left",
    q: "left",
    Q: "left",
    d: "right",
    D: "right"
  };

  var VECTOR = {
    up: { x: 0, y: -1 },
    down: { x: 0, y: 1 },
    left: { x: -1, y: 0 },
    right: { x: 1, y: 0 }
  };

  var roots = document.querySelectorAll(".noxland-game");

  if (!roots.length) {
    return;
  }

  roots.forEach(function (root) {
    try {
      initNoxland(root);
    } catch (error) {
      root.classList.remove("noxland-is-enhanced");
      if (window.console && window.console.warn) {
        window.console.warn("NOXLAND failed to initialize.", error);
      }
    }
  });

  function initNoxland(root) {
    applyPageFullscreen(root);

    if (root.dataset.noxlandReady === "true") {
      return;
    }

    var stage = root.querySelector(".noxland-stage");
    var player = root.querySelector(".noxland-player");
    var overlay = root.querySelector(".noxland-overlay");
    var overlayTitle = root.querySelector(".noxland-overlay__title");
    var overlayText = root.querySelector(".noxland-overlay__text");
    var overlayEnter = root.querySelector(".noxland-overlay__enter");
    var overlayStay = root.querySelector(".noxland-overlay__stay");
    var zoneHint = root.querySelector(".noxland-zone-hint");
    var audio = root.querySelector(".noxland-audio");
    var audioToggle = root.querySelector("[data-audio-toggle]");
    var buildingNodes = Array.prototype.slice.call(root.querySelectorAll(".noxland-building"));
    var dpadButtons = Array.prototype.slice.call(root.querySelectorAll(".noxland-dpad__button"));

    if (!stage || !player || !overlay || !buildingNodes.length) {
      return;
    }

    // Movement is percentage-based so the placeholder art can be replaced later.
    var state = {
      x: readNumber(stage.dataset.playerStartX, 50),
      y: readNumber(stage.dataset.playerStartY, 73),
      keys: new Set(),
      touches: new Set(),
      running: false,
      lastFrame: 0,
      overlayOpen: false,
      dismissedRoomId: "",
      currentRoomId: ""
    };

    // Room zones also use percentage coordinates and stay responsive with the map.
    var rooms = buildingNodes.map(function (node) {
      return {
        node: node,
        id: node.dataset.roomId || "",
        title: node.dataset.roomTitle || "NOXLAND",
        text: node.dataset.roomText || "",
        button: node.dataset.roomButton || "Enter room",
        url: node.dataset.roomUrl || "/collections/all",
        zone: {
          x: readNumber(node.dataset.zoneX, 0),
          y: readNumber(node.dataset.zoneY, 0),
          w: readNumber(node.dataset.zoneW, 0),
          h: readNumber(node.dataset.zoneH, 0)
        }
      };
    });

    setPlayerPosition(root, state);
    updateHint(zoneHint, "Move with WASD / arrows. Find a door.");
    bindKeyboard(state, zoneHint);
    bindStageFocus(stage);
    bindBuildings(rooms, state, zoneHint);
    bindOverlay(stage, overlay, overlayStay, state);
    bindAudio(root, audio, audioToggle);
    bindDpad(dpadButtons, state, function (direction) {
      if (state.overlayOpen) {
        return;
      }

      moveByDirection(state, direction, 4.2);
      setPlayerPosition(root, state);
      detectRoom(state, rooms, zoneHint, openRoom);
    });

    root.dataset.noxlandReady = "true";
    root.classList.add("noxland-is-enhanced");
    startLoop(root, state, rooms, zoneHint, openRoom);

    function openRoom(room) {
      state.overlayOpen = true;
      state.currentRoomId = room.id;
      state.keys.clear();
      state.touches.clear();
      setDpadActive(dpadButtons, state);

      overlayTitle.textContent = room.title;
      overlayText.textContent = room.text;
      overlayEnter.textContent = room.button;
      overlayEnter.setAttribute("href", room.url || "/collections/all");
      overlay.hidden = false;

      window.setTimeout(function () {
        overlayEnter.focus();
      }, 0);
    }
  }

  function bindAudio(root, audio, toggle) {
    if (!toggle) {
      return;
    }

    if (!audio) {
      toggle.hidden = true;
      return;
    }

    audio.volume = 0;

    var shouldReact = audio.dataset.audioReactive !== "false";
    var wantsSound = readStorage(SOUND_STORAGE_KEY) === "on";
    var cancelAutoStart = null;
    updateAudioToggle(toggle, false);

    if (wantsSound) {
      cancelAutoStart = playAudioAfterInteraction(root, audio, toggle, shouldReact);
    }

    toggle.addEventListener("click", function () {
      if (cancelAutoStart) {
        cancelAutoStart();
        cancelAutoStart = null;
      }

      if (isAudioPlaying(audio)) {
        pauseAudio(root, audio, toggle);
        writeStorage(SOUND_STORAGE_KEY, "off");
        return;
      }

      writeStorage(SOUND_STORAGE_KEY, "on");
      playAudio(root, audio, toggle, shouldReact);
    });

    audio.addEventListener("error", function () {
      updateAudioToggle(toggle, false);
      toggle.disabled = true;
      toggle.title = "Audio unavailable";
      writeStorage(SOUND_STORAGE_KEY, "off");
    });
  }

  function playAudioAfterInteraction(root, audio, toggle, shouldReact) {
    var started = false;

    var cleanup = function () {
      document.removeEventListener("pointerdown", tryStart);
      document.removeEventListener("keydown", tryStart);
      document.removeEventListener("touchstart", tryStart);
    };

    var tryStart = function (event) {
      if (toggle && event && toggle.contains(event.target)) {
        return;
      }

      if (started || isAudioPlaying(audio)) {
        cleanup();
        return;
      }

      started = true;
      cleanup();
      playAudio(root, audio, toggle, shouldReact);
    };

    document.addEventListener("pointerdown", tryStart, { once: true });
    document.addEventListener("keydown", tryStart, { once: true });
    document.addEventListener("touchstart", tryStart, { once: true });

    return cleanup;
  }

  function playAudio(root, audio, toggle, shouldReact) {
    if (!audio) {
      return;
    }

    var targetVolume = getAudioTargetVolume(audio);

    cancelAudioFade(audio);
    audio.volume = 0;
    audio.muted = false;

    var playPromise = audio.play();

    if (!playPromise || typeof playPromise.then !== "function") {
      updateAudioToggle(toggle, true);
      fadeAudioTo(audio, targetVolume, readNumber(audio.dataset.fadeDuration, DEFAULT_AUDIO_FADE_MS));
      if (shouldReact) {
        startAudioReactivity(root, audio);
      } else {
        resetAudioReactivity(root);
      }
      return;
    }

    playPromise.then(function () {
      updateAudioToggle(toggle, true);
      fadeAudioTo(audio, targetVolume, readNumber(audio.dataset.fadeDuration, DEFAULT_AUDIO_FADE_MS));
      if (shouldReact) {
        startAudioReactivity(root, audio);
      } else {
        resetAudioReactivity(root);
      }
    }).catch(function () {
      updateAudioToggle(toggle, false);
      resetAudioReactivity(root);
      writeStorage(SOUND_STORAGE_KEY, "off");
    });
  }

  function pauseAudio(root, audio, toggle) {
    if (audio) {
      cancelAudioFade(audio);
      audio.pause();
      audio.volume = 0;
    }

    resetAudioReactivity(root);
    updateAudioToggle(toggle, false);
  }

  function isAudioPlaying(audio) {
    return Boolean(audio && !audio.paused && !audio.ended);
  }

  function getAudioTargetVolume(audio) {
    return clamp(readNumber(audio && audio.dataset.volume, DEFAULT_AUDIO_VOLUME), 0, 1);
  }

  function fadeAudioTo(audio, targetVolume, duration) {
    if (!audio) {
      return;
    }

    cancelAudioFade(audio);

    if (duration <= 0 || prefersReducedMotion()) {
      audio.volume = targetVolume;
      return;
    }

    var startVolume = audio.volume;
    var startedAt = window.performance && window.performance.now ? window.performance.now() : Date.now();

    var tick = function (timestamp) {
      var elapsed = timestamp - startedAt;
      var progress = clamp(elapsed / duration, 0, 1);
      var eased = 1 - Math.pow(1 - progress, 3);

      audio.volume = startVolume + (targetVolume - startVolume) * eased;

      if (progress < 1 && !audio.paused) {
        audio.__noxlandFadeFrame = window.requestAnimationFrame(tick);
        return;
      }

      audio.volume = audio.paused ? 0 : targetVolume;
      audio.__noxlandFadeFrame = null;
    };

    audio.__noxlandFadeFrame = window.requestAnimationFrame(tick);
  }

  function cancelAudioFade(audio) {
    if (!audio || !audio.__noxlandFadeFrame) {
      return;
    }

    window.cancelAnimationFrame(audio.__noxlandFadeFrame);
    audio.__noxlandFadeFrame = null;
  }

  function updateAudioToggle(toggle, isOn) {
    if (!toggle) {
      return;
    }

    toggle.textContent = isOn ? "Sound: On" : "Sound: Off";
    toggle.setAttribute("aria-pressed", isOn ? "true" : "false");
  }

  function startAudioReactivity(root, audio) {
    if (!root || !audio || audio.dataset.audioReactive === "false") {
      resetAudioReactivity(root);
      return;
    }

    root.dataset.noxlandAudioIntensity = audio.dataset.reactiveIntensity || "30";
    startFallbackAudioReactivity(root, audio);

    if (!(window.AudioContext || window.webkitAudioContext) || !canUseAudioAnalyzer(audio)) {
      return;
    }

    if (!root.__noxlandAudioReactive) {
      root.__noxlandAudioReactive = createAudioReactiveState(root, audio);
    }

    var reactive = root.__noxlandAudioReactive;

    if (!reactive || !reactive.context) {
      startFallbackAudioReactivity(root, audio);
      return;
    }

    var activate = function () {
      stopFallbackAudioReactivity(root);
      reactive.active = true;
      root.classList.add("noxland-audio-reactive");

      if (!reactive.running) {
        reactive.running = true;
        window.requestAnimationFrame(function (timestamp) {
          tickAudioReactivity(root, reactive, timestamp);
        });
      }
    };

    var resumePromise = null;

    if (reactive.context.state === "suspended" && typeof reactive.context.resume === "function") {
      resumePromise = reactive.context.resume();
    }

    if (!resumePromise || typeof resumePromise.then !== "function") {
      activate();
      return;
    }

    resumePromise.then(activate).catch(function () {
      startFallbackAudioReactivity(root, audio);
    });
  }

  function createAudioReactiveState(root, audio) {
    var AudioContextClass = window.AudioContext || window.webkitAudioContext;

    try {
      var context = new AudioContextClass();
      var source = audio.__noxlandMediaSource || context.createMediaElementSource(audio);
      var analyser = context.createAnalyser();

      audio.__noxlandMediaSource = source;
      analyser.fftSize = 128;
      analyser.smoothingTimeConstant = 0.72;
      source.connect(analyser);
      analyser.connect(context.destination);

      return {
        context: context,
        analyser: analyser,
        audio: audio,
        data: new Uint8Array(analyser.frequencyBinCount),
        active: false,
        running: false,
        bass: 0,
        mid: 0,
        beat: 0,
        floor: 0.16,
        lastBeat: 0,
        silentFrames: 0
      };
    } catch (error) {
      startFallbackAudioReactivity(root, audio);
      return null;
    }
  }

  function tickAudioReactivity(root, reactive, timestamp) {
    if (!root || !reactive || !reactive.analyser) {
      return;
    }

    reactive.analyser.getByteFrequencyData(reactive.data);

    var bass = averageBins(reactive.data, 1, 7) / 255;
    var mid = averageBins(reactive.data, 8, 22) / 255;
    var energy = bass * 0.78 + mid * 0.22;
    var threshold = Math.max(0.24, reactive.floor * 1.42);
    var isBeat = energy > threshold && timestamp - reactive.lastBeat > 140;

    reactive.floor = reactive.floor * 0.985 + energy * 0.015;
    reactive.bass = reactive.bass * 0.78 + bass * 0.22;
    reactive.mid = reactive.mid * 0.82 + mid * 0.18;
    reactive.beat = Math.max(isBeat ? 1 : 0, reactive.beat * 0.82);

    if (isBeat) {
      reactive.lastBeat = timestamp;
    }

    reactive.silentFrames = energy < 0.015 && reactive.audio && reactive.audio.currentTime > 1.2 ? reactive.silentFrames + 1 : 0;

    if (reactive.silentFrames > 70) {
      reactive.active = false;
      reactive.running = false;
      startFallbackAudioReactivity(root, reactive.audio);
      return;
    }

    applyAudioReactiveVars(root, reactive.bass, reactive.mid, reactive.beat);

    if (!reactive.active) {
      reactive.running = false;
      return;
    }

    window.requestAnimationFrame(function (nextTimestamp) {
      tickAudioReactivity(root, reactive, nextTimestamp);
    });
  }

  function startFallbackAudioReactivity(root, audio) {
    if (!root || !audio) {
      return;
    }

    if (!root.__noxlandAudioFallback) {
      root.__noxlandAudioFallback = {
        active: false,
        running: false,
        bass: 0,
        mid: 0,
        beat: 0
      };
    }

    var fallback = root.__noxlandAudioFallback;
    fallback.active = true;
    root.classList.add("noxland-audio-reactive", "noxland-audio-reactive--fallback");

    if (fallback.running) {
      return;
    }

    fallback.running = true;
    window.requestAnimationFrame(function (timestamp) {
      tickFallbackAudioReactivity(root, audio, fallback, timestamp);
    });
  }

  function tickFallbackAudioReactivity(root, audio, fallback, timestamp) {
    if (!root || !audio || !fallback || !fallback.active || !isAudioPlaying(audio)) {
      if (fallback) {
        fallback.running = false;
      }
      return;
    }

    var bpm = clamp(readNumber(audio.dataset.reactiveBpm, DEFAULT_REACTIVE_BPM), 80, 220);
    var seconds = audio.currentTime || timestamp / 1000;
    var phase = (seconds * bpm / 60) % 1;
    var halfPhase = (seconds * bpm / 30) % 1;
    var pulse = Math.pow(Math.max(0, Math.sin(phase * Math.PI)), 2.8);
    var offPulse = Math.pow(Math.max(0, Math.sin(halfPhase * Math.PI)), 3.2) * 0.38;
    var beat = Math.max(pulse, offPulse);
    var bass = 0.28 + beat * 0.72;
    var mid = 0.2 + Math.max(offPulse, pulse * 0.42);

    fallback.bass = fallback.bass * 0.68 + bass * 0.32;
    fallback.mid = fallback.mid * 0.74 + mid * 0.26;
    fallback.beat = Math.max(beat, fallback.beat * 0.72);

    applyAudioReactiveVars(root, fallback.bass, fallback.mid, fallback.beat);

    window.requestAnimationFrame(function (nextTimestamp) {
      tickFallbackAudioReactivity(root, audio, fallback, nextTimestamp);
    });
  }

  function stopFallbackAudioReactivity(root) {
    if (!root || !root.__noxlandAudioFallback) {
      return;
    }

    root.__noxlandAudioFallback.active = false;
    root.__noxlandAudioFallback.running = false;
    root.classList.remove("noxland-audio-reactive--fallback");
  }

  function applyAudioReactiveVars(root, bass, mid, beat) {
    var intensity = getAudioReactiveIntensity(root);
    var scaledBass = bass * intensity;
    var scaledMid = mid * intensity;
    var scaledBeat = beat * intensity;

    root.style.setProperty("--noxland-audio-bass", scaledBass.toFixed(3));
    root.style.setProperty("--noxland-audio-mid", scaledMid.toFixed(3));
    root.style.setProperty("--noxland-audio-beat", scaledBeat.toFixed(3));
    root.style.setProperty("--noxland-audio-map-scale", (1 + scaledBeat * 0.008 + scaledBass * 0.004).toFixed(4));
    root.style.setProperty("--noxland-audio-brightness", (0.74 + scaledBass * 0.08 + scaledBeat * 0.025).toFixed(3));
    root.style.setProperty("--noxland-audio-contrast", (1.08 + scaledBeat * 0.05).toFixed(3));
    root.style.setProperty("--noxland-audio-saturate", (0.82 + scaledBass * 0.12).toFixed(3));
    root.style.setProperty("--noxland-audio-grain-opacity", (0.58 + scaledMid * 0.08 + scaledBeat * 0.04).toFixed(3));
    root.style.setProperty("--noxland-audio-red-alpha", (0.08 + scaledBass * 0.1 + scaledBeat * 0.06).toFixed(3));
    root.style.setProperty("--noxland-audio-ember-opacity", (0.42 + scaledBass * 0.16).toFixed(3));
  }

  function getAudioReactiveIntensity(root) {
    return clamp(readNumber(root && root.dataset.noxlandAudioIntensity, 30), 0, 100) / 100;
  }

  function canUseAudioAnalyzer(audio) {
    var source = audio.currentSrc || audio.src;
    var sourceNode = audio.querySelector && audio.querySelector("source");

    if (!source && sourceNode) {
      source = sourceNode.src;
    }

    if (!source) {
      return false;
    }

    try {
      return new URL(source, window.location.href).origin === window.location.origin;
    } catch (error) {
      return false;
    }
  }

  function resetAudioReactivity(root) {
    if (!root) {
      return;
    }

    stopFallbackAudioReactivity(root);

    if (root.__noxlandAudioReactive) {
      root.__noxlandAudioReactive.active = false;
      root.__noxlandAudioReactive.bass = 0;
      root.__noxlandAudioReactive.mid = 0;
      root.__noxlandAudioReactive.beat = 0;
    }

    root.classList.remove("noxland-audio-reactive");
    root.style.setProperty("--noxland-audio-bass", "0");
    root.style.setProperty("--noxland-audio-mid", "0");
    root.style.setProperty("--noxland-audio-beat", "0");
    root.style.setProperty("--noxland-audio-map-scale", "1");
    root.style.setProperty("--noxland-audio-brightness", "0.74");
    root.style.setProperty("--noxland-audio-contrast", "1.08");
    root.style.setProperty("--noxland-audio-saturate", "0.82");
    root.style.setProperty("--noxland-audio-grain-opacity", "0.58");
    root.style.setProperty("--noxland-audio-red-alpha", "0.08");
    root.style.setProperty("--noxland-audio-ember-opacity", "0.42");
  }

  function averageBins(data, start, end) {
    var total = 0;
    var count = 0;
    var max = Math.min(end, data.length - 1);

    for (var index = start; index <= max; index += 1) {
      total += data[index];
      count += 1;
    }

    return count ? total / count : 0;
  }

  function applyPageFullscreen(root) {
    if (root.dataset.noxlandFullscreen !== "true") {
      return;
    }

    document.documentElement.classList.add(FULLSCREEN_PAGE_CLASS);

    if (document.body) {
      document.body.classList.add(FULLSCREEN_PAGE_CLASS);
    }

    bindFullscreenCleanup();
  }

  function bindFullscreenCleanup() {
    if (document.documentElement.dataset.noxlandFullscreenCleanup === "true") {
      return;
    }

    document.documentElement.dataset.noxlandFullscreenCleanup = "true";
    document.addEventListener("shopify:section:load", syncFullscreenClass);
    document.addEventListener("shopify:section:unload", function () {
      window.setTimeout(syncFullscreenClass, 0);
    });
  }

  function syncFullscreenClass() {
    var hasFullscreenNoxland = Boolean(document.querySelector(".noxland-game[data-noxland-fullscreen='true']"));

    document.documentElement.classList.toggle(FULLSCREEN_PAGE_CLASS, hasFullscreenNoxland);

    if (document.body) {
      document.body.classList.toggle(FULLSCREEN_PAGE_CLASS, hasFullscreenNoxland);
    }
  }

  function bindKeyboard(state, zoneHint) {
    document.addEventListener("keydown", function (event) {
      var direction = KEY_DIRECTIONS[event.key];

      if (!direction || state.overlayOpen || isTypingTarget(event.target)) {
        return;
      }

      event.preventDefault();
      state.keys.add(direction);
      updateHint(zoneHint, "Approach a structure to enter.");
    });

    document.addEventListener("keyup", function (event) {
      var direction = KEY_DIRECTIONS[event.key];

      if (!direction) {
        return;
      }

      state.keys.delete(direction);
    });
  }

  function bindStageFocus(stage) {
    stage.addEventListener("pointerdown", function () {
      focusWithoutScroll(stage);
    });
  }

  function bindBuildings(rooms, state, zoneHint) {
    rooms.forEach(function (room) {
      room.node.addEventListener("click", function () {
        state.dismissedRoomId = "";
        updateHint(zoneHint, room.title);
        room.node.dispatchEvent(new CustomEvent("noxland:room", { bubbles: true, detail: room }));
      });
    });
  }

  function bindOverlay(stage, overlay, overlayStay, state) {
    overlayStay.addEventListener("click", function () {
      state.overlayOpen = false;
      state.dismissedRoomId = state.currentRoomId;
      overlay.hidden = true;
      focusWithoutScroll(stage);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape" || !state.overlayOpen) {
        return;
      }

      state.overlayOpen = false;
      state.dismissedRoomId = state.currentRoomId;
      overlay.hidden = true;
      focusWithoutScroll(stage);
    });
  }

  function bindDpad(buttons, state, onTap) {
    buttons.forEach(function (button) {
      var direction = button.dataset.move;

      if (!VECTOR[direction]) {
        return;
      }

      button.addEventListener("pointerdown", function (event) {
        event.preventDefault();
        state.touches.add(direction);
        setDpadActive(buttons, state);
      });

      button.addEventListener("pointerup", function () {
        state.touches.delete(direction);
        setDpadActive(buttons, state);
      });

      button.addEventListener("pointerleave", function () {
        state.touches.delete(direction);
        setDpadActive(buttons, state);
      });

      button.addEventListener("pointercancel", function () {
        state.touches.delete(direction);
        setDpadActive(buttons, state);
      });

      button.addEventListener("click", function () {
        onTap(direction);
      });
    });
  }

  function startLoop(root, state, rooms, zoneHint, openRoom) {
    if (state.running) {
      return;
    }

    // One tiny loop per section keeps keyboard and touch movement in sync.
    if (rooms) {
      root.addEventListener("noxland:room", function (event) {
        openRoom(event.detail);
      });
    }

    state.running = true;
    state.lastFrame = 0;

    window.requestAnimationFrame(function tick(timestamp) {
      if (!state.lastFrame) {
        state.lastFrame = timestamp;
      }

      var delta = Math.min((timestamp - state.lastFrame) / 1000, 0.05);
      state.lastFrame = timestamp;

      if (!state.overlayOpen) {
        var movement = getMovement(state);
        var hasMovement = movement.x !== 0 || movement.y !== 0;

        if (hasMovement) {
          var speed = 20;
          state.x = clamp(state.x + movement.x * speed * delta, 6, 94);
          state.y = clamp(state.y + movement.y * speed * delta, 16, 88);
          setPlayerPosition(root, state);
        }

        root.classList.toggle("noxland-player--moving", hasMovement);

        if (rooms) {
          detectRoom(state, rooms, zoneHint, openRoom);
        }
      }

      window.requestAnimationFrame(tick);
    });
  }

  function getMovement(state) {
    var movement = { x: 0, y: 0 };

    state.keys.forEach(function (direction) {
      movement.x += VECTOR[direction].x;
      movement.y += VECTOR[direction].y;
    });

    state.touches.forEach(function (direction) {
      movement.x += VECTOR[direction].x;
      movement.y += VECTOR[direction].y;
    });

    if (movement.x !== 0 && movement.y !== 0) {
      movement.x *= 0.7071;
      movement.y *= 0.7071;
    }

    return movement;
  }

  function moveByDirection(state, direction, amount) {
    var vector = VECTOR[direction];

    if (!vector) {
      return;
    }

    state.x = clamp(state.x + vector.x * amount, 6, 94);
    state.y = clamp(state.y + vector.y * amount, 16, 88);
  }

  function detectRoom(state, rooms, zoneHint, openRoom) {
    var room = rooms.find(function (item) {
      return state.x >= item.zone.x &&
        state.x <= item.zone.x + item.zone.w &&
        state.y >= item.zone.y &&
        state.y <= item.zone.y + item.zone.h;
    });

    if (!room) {
      state.currentRoomId = "";
      state.dismissedRoomId = "";
      updateHint(zoneHint, "Move with WASD / arrows. Find a door.");
      return;
    }

    state.currentRoomId = room.id;
    updateHint(zoneHint, "Door found: " + room.title);

    if (state.dismissedRoomId === room.id || state.overlayOpen) {
      return;
    }

    openRoom(room);
  }

  function setPlayerPosition(root, state) {
    root.style.setProperty("--noxland-player-x", state.x + "%");
    root.style.setProperty("--noxland-player-y", state.y + "%");
  }

  function setDpadActive(buttons, state) {
    buttons.forEach(function (button) {
      button.classList.toggle("noxland-dpad__button--active", state.touches.has(button.dataset.move));
    });
  }

  function updateHint(zoneHint, text) {
    if (zoneHint) {
      zoneHint.textContent = text;
    }
  }

  function readNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function prefersReducedMotion() {
    return Boolean(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function isTypingTarget(target) {
    if (!target) {
      return false;
    }

    return Boolean(target.closest("input, textarea, select, [contenteditable='true']"));
  }

  function focusWithoutScroll(element) {
    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      return;
    }
  }
})();
